import client from "shared/utils/axios-config";
import { SaveScheduleDraftForm, ScheduleDraft } from "shared/types";

// Saved create-schedule drafts (/v2/schedule-draft). The server scopes every
// call to the acting admin (business + creator), so these take no ids beyond
// the draft's own.

export const getScheduleDrafts = async (): Promise<ScheduleDraft[]> => {
  const res = await client.get(`/v2/schedule-draft/`);
  return res.data.data;
};

export const createScheduleDraft = async (
  form: SaveScheduleDraftForm,
): Promise<ScheduleDraft> => {
  const res = await client.post(`/v2/schedule-draft/`, form);
  return res.data.data;
};

export const updateScheduleDraft = async (
  draft_id: string,
  form: SaveScheduleDraftForm,
) => {
  const res = await client.put(`/v2/schedule-draft/${draft_id}`, form);
  return res.data;
};

export const deleteScheduleDraft = async (draft_id: string) => {
  const res = await client.delete(`/v2/schedule-draft/${draft_id}`);
  return res.data;
};
